/**
 * Programme une recherche après une pause de saisie et ignore les réponses
 * qui ne correspondent plus à la valeur actuellement saisie.
 */
export function createDebouncedSearch(searchFunction, {
    delay = 400,
    minLength = 3,
    onResults,
    onError = () => {}
} = {}) {
    let timeoutId = null;
    let searchVersion = 0;

    const search = (value) => {
        const term = typeof value === 'string' ? value.trim() : '';
        const currentVersion = ++searchVersion;

        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }

        if (term.length < minLength) {
            onResults([]);
            return;
        }

        timeoutId = setTimeout(async () => {
            timeoutId = null;

            try {
                const results = await searchFunction(term);

                // Une réponse lente d'une ancienne recherche ne doit jamais
                // remplacer les suggestions de la saisie la plus récente.
                if (currentVersion === searchVersion) {
                    onResults(Array.isArray(results) ? results : []);
                }
            } catch (error) {
                if (currentVersion === searchVersion) {
                    onError(error);
                    onResults([]);
                }
            }
        }, delay);
    };

    search.cancel = () => {
        searchVersion++;

        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };

    return search;
}
